import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import imgUrl from '../../assets/images/imgUrl';

const theme = createTheme({
  palette: {
    darkPink: { main: '#156082' },
    darkPurple: { main: '#156082' },
    darkBlue: { main: '#156082' },
    connector: { main: '#1e3a8a' },
    subNodeBg: { main: '#156082' },
  },
});

const OrgChartNode = ({ title, color }) => (
  <Box
    sx={{
      bgcolor: color,
      color: 'white',
      borderRadius: '8px',
      p: 2,
      boxShadow: 2,
      textAlign: 'center',
      minWidth: 200,
      maxWidth: 260,
      width: '100%',
      whiteSpace: 'pre-line',
      fontSize: { xs: '0.85rem', sm: '1rem', md: 'inherit' },
    }}
  >
    <Typography variant="body2" fontWeight="medium">
      {title}
    </Typography>
  </Box>
);

const ProgrammeSubNodes = () => {
  const items = [
    'I Am Peacekeeper Schools & I Am Peacekeeper Campuses',
    'I Am Peacekeeper Organisations & I Am Peacekeeper Corporates',
    'I Am Peacekeeper Events',
    'I Am Peacekeeper Cities',
    'I Am Peacekeeper Networks',
    'I Am Peacekeeper Gifts',
    'I Am Peacekeeper Courses',
    'I Am Peacekeeper Influencers',
    'I Am Peacekeeper Welfare Fund',
    'I Am Peacekeeper Cafee',
    'I Am Peacekeeper Voices',
    'I Am Peacekeeper Arts & I Am Peacekeeper Publications',
  ];

  return (
    <Box
      sx={{
        bgcolor: 'subNodeBg.main',
        color: 'white',
        borderRadius: 1,
        p: 2,
        mt: 0,
        minWidth: 300,
        maxWidth: 320,
        textAlign: 'left',
        fontSize: '0.75rem',
        lineHeight: 1.4,
        boxShadow: 3,
        whiteSpace: 'normal',
        width: { xs: '100%', sm: 320 },
      }}
    >
      {items.map((item, idx) => (
        <Typography key={idx} sx={{ mb: idx !== items.length - 1 ? 0.5 : 0 }}>
          {item}
        </Typography>
      ))}
    </Box>
  );
};

const OrgChart = () => {
  return (
    <ThemeProvider theme={theme}>
      {/* <Box
        mt={2}
        sx={{
          p: { xs: 2, sm: 4 },
        //   minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      > */}
       

        {/* Founder & Advisory Board */}
        {/* <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            position: 'relative',
            mb: 0,
            width: '100%',
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'center', sm: 'flex-start' },
          }}
        > */}
          {/* Founder */}
          {/* <Box sx={{ textAlign: 'center', zIndex: 2, mb: { xs: 2, sm: 0 } }}>
            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{
                border: '1px solid #4b5563',
                display: 'inline-block',
                px: 2,
                py: 1,
                borderRadius: 1,
                bgcolor: '#156082',
                color: '#fff',
              }}
            > */}
              {/* Dr Huzaifa Khorakiwala, Founder
            </Typography> */}

            {/* Vertical line to Council */}
            {/* <Box
              sx={{
                width: '2px',
                height: { xs: 20, sm: 40 },
                bgcolor: 'connector.main',
                mx: 'auto',
                mt: 0,
              }}
            />
          </Box> */}

          {/* Advisory Board */}
          {/* <Box
            sx={{
              position: { xs: 'relative', sm: 'absolute' },
              top: { sm: '10px' },
              left: { sm: 'calc(50% + 20px)' },
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: { xs: 'center', sm: 'flex-start' },
              width: '100%',
              mt: { xs: 1, sm: 0 },
              mb: { xs: 2, sm: 0 },
              gap: 2,
            }}
            className="advisoryBoard"
          > */}
            {/* Dashed line - desktop only */}
            {/* <Box
              sx={{
                display: { xs: 'none', sm: 'block' },
                width: { sm: 120, md: 160 },
                height: 2,
                borderTop: '2px dashed #15803d',
                mt: { sm: '36px', md: '36px' },
              }}
            /> */}
            {/* Advisory Board Box */}
            {/* <Box
              sx={{
                border: '2px dashed #22c55e',
                bgcolor: '#B4E5A2',
                borderRadius: 2,
                p: 1,
                minWidth: { xs: 160, sm: 180, md: 200 },
                maxWidth: { xs: 200, sm: 240 },
                textAlign: 'center',
                mt: { xs: 0, sm: '30px' },
                color: '#000',
                fontSize: { xs: '0.8rem', sm: '0.9rem', md: 'inherit' },
              }}
            >
              <Typography variant="body2" fontWeight="bold" color="#15803d">
                Advisory Board
              </Typography>
            </Box>
          </Box> */}
        {/* </Box> */}

        {/* International Governing Council */}
        {/* <Box sx={{ textAlign: 'center', mb: 0, mt: 0 }}>
          <Typography
            variant="body2"
            fontWeight="bold"
            sx={{
              border: '1px solid #4b5563',
              display: 'inline-block',
              px: 2,
              py: 1,
              borderRadius: 1,
              bgcolor: '#e0f2fe',
              fontSize: { xs: '0.85rem', sm: '1rem', md: 'inherit' },
            }}
          >
            International Governing Council
          </Typography>
        </Box> */}

        {/* Connectors from Council to 3 branches */}
        {/* <Box
          sx={{
            position: 'relative',
            height: { xs: 60, sm: 40 },
            width: '100%',
            maxWidth: 800,
            mb: 0,
          }}
        > */}
          {/* Vertical line from Council */}
          {/* <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '2px',
              height: { xs: 30, sm: 20 },
              bgcolor: 'connector.main',
            }}
          /> */}
          {/* Horizontal line across */}
          {/* <Box
            sx={{
              position: 'absolute',
              top: { xs: 30, sm: 20 },
              left: { xs: 'calc(15%)', sm: '10%' },
              width: { xs: '70%', sm: '80%' },
              height: '2px',
              bgcolor: 'connector.main',
            }}
          /> */}
          {/* Vertical lines down to each node */}
          {/* {['15%', '50%', '85%'].map((left, idx) => (
            <Box
              key={idx}
              sx={{
                position: 'absolute',
                top: { xs: 30, sm: 20 },
                left,
                width: '2px',
                height: { xs: 30, sm: 20 },
                bgcolor: 'connector.main',
              }}
            />
          ))}
        </Box> */}

        {/* Three Main Nodes */}
        {/* <Stack
          direction={{ xs: 'column', sm: 'column', md: 'row' }}
          spacing={{ xs: 4, sm: 4, md: 6 }}
          justifyContent="center"
          alignItems={{ xs: 'center', sm: 'center', md: 'flex-start' }}
          sx={{ width: '100%', maxWidth: 1200, mt: 0 }}
        >
          <OrgChartNode title={`Relationships &\nMovement Building`} color="darkPink.main" />
          <OrgChartNode title={'Administration &\n& Services'} color="darkPurple.main" /> */}

          {/* <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              maxWidth: 320,
              position: 'relative',
              width: '100%',
              mt: { xs: 4, sm: 4, md: 0 },
            }}
          >
            <OrgChartNode title="Programme Management (International Heads)" color="darkBlue.main" /> */}

            {/* Vertical connector line */}
            {/* <Box
              sx={{
                width: '2px',
                height: { xs: 15, sm: 20 },
                bgcolor: 'connector.main',
                mt: 0,
                mb: 0,
              }}
            /> */}

            {/* Subnodes Box */}
            {/* <ProgrammeSubNodes />
          </Box>
        </Stack>
      </Box> */}

      <Box
        mt={2}
        className="teamCharts"
        sx={{
          p: { xs: 2, sm: 4 },
        //   minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img src={imgUrl.teamChart} alt='Team Hierarchy' className='desktopTeamchart'></img>

        {/* mobile chart */}
        <img src={imgUrl.teamChartMobile} alt='Team Hierarchy' className='mobileTeamChart'></img>

        {/* tablet chart */}
        <img src={imgUrl.teamChartTablet} alt='Team Hierarchy' className='tabletTeamChart'></img>
      </Box>
    </ThemeProvider>
  );
};

export default OrgChart;
